(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pocket-marimo-invitation"] && !Shopify.designMode) return;
  try {
    (() => {
  const invite=document.getElementById('pocket-marimo-invite');
  if(!invite)return;
  const key='pocket-marimo-invited-v1';
  try{if(sessionStorage.getItem(key))return;}catch{}
  const close=()=>{invite.hidden=true;try{sessionStorage.setItem(key,'1');}catch{}};
  invite.querySelector('.pm-dismiss').addEventListener('click',close);
  invite.querySelector('a').addEventListener('click',close);
  const show=()=>{
    const isOpen=(el)=>!el.closest('[hidden]') && el.getClientRects().length>0;
    const blocked=document.hidden || document.body.classList.contains('js-drawer-open') || document.documentElement.classList.contains('mm-lock') || Array.from(document.querySelectorAll('dialog[open], [aria-modal="true"], .drawer--is-open')).some(isOpen);
    if(blocked){
      window.setTimeout(show,2000);return;
    }
    invite.hidden=false;
    try{sessionStorage.setItem(key,'1');}catch{}
  };
  window.setTimeout(show,7000);
})();
  } catch(e) { console.error(e); }
})();

})();
